// extracted by mini-css-extract-plugin
module.exports = {"contentBlock":"ContentBlock_contentBlock__OfC_M"};